var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Leading Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.87 10.8363C13.6842 11.0407 13.368 11.0557 13.1637 10.87L8 6.17573L2.83634 10.87C2.63201 11.0557 2.31579 11.0407 2.13003 10.8363C1.94428 10.632 1.95934 10.3158 2.16367 10.13L7.66367 5.13003C7.85438 4.95666 8.14563 4.95666 8.33634 5.13003L13.8363 10.13C14.0407 10.3158 14.0557 10.632 13.87 10.8363Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUp);
export default __webpack_public_path__ + "static/media/caret-up.eaa7f2e62f622ba9552f8e426cdf452e.svg";
export { ForwardRef as ReactComponent };